exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".animation-enter[data-v-cf092e0e] {\n  animation: enter-data-v-cf092e0e 0.3s;\n}\n.animation-leave[data-v-cf092e0e] {\n  animation: leave-data-v-cf092e0e 0.3s;\n}\n@keyframes enter-data-v-cf092e0e {\nfrom {\n    transform: translateX(500px);\n    opacity: 0;\n}\nto {\n    transform: translateX(0);\n    opacity: 1;\n}\n}\n@keyframes leave-data-v-cf092e0e {\nfrom {\n    transform: translateX(0);\n    opacity: 1;\n}\nto {\n    transform: translateX(500px);\n    opacity: 0;\n}\n}\n", ""]);

// exports
